import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Button, Text } from 'grommet'
import { graphql, StaticQuery } from "gatsby";

class BioLink extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      hover: false,
    };
    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHover() {
    this.setState({ hover: !this.state.hover })
  }

  render() {
    const to = this.props.to
    const label = this.props.label
    console.log(label)
    const { data } = this.props
    const icon = this.props.icon //Home
    console.log(data)
    const text = (<Text size='0.6em' color='text' >{label}</Text>)

    var linkStyle;
    if (this.state.hover) {
      linkStyle = { backgroundColor: "#555555" }
    } else {
      linkStyle = { backgroundColor: '' }
    }

    return (
      <Link to={to} style={linkStyle} onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
        <Button
          label={text}
          plain={true}
          //style={{paddingLeft: '16px'}}
          icon={icon}
            //<Img
            //  fluid={data.imageSharp.fluid}
            //  style={{
            //    width: "1.3em",
            //  }}
            ///>}>
        />
      </Link>
    )
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        imageSharp(fluid: { originalName: {regex: "/avatar.png/" }}) {
            fluid (maxWidth: 40, maxHeight: 40){
              ...GatsbyImageSharpFluid_tracedSVG
            }
        }
      }
    `}
    render={data => <BioLink data={data} {...props} />}
  />
)
